import React, { Component } from 'react';
import {List, Icon, Flex, ActionSheet, Calendar, WingBlank, Toast, WhiteSpace, Modal} from 'antd-mobile';
import df from 'dateformat'
import send from '../../../utils/send';
import ListImg from '../../../components/ListImg'

const isIPhone = new RegExp('\\biPhone\\b|\\biPod\\b', 'i').test(window.navigator.userAgent);
let wrapProps;
if (isIPhone) {
  wrapProps = {
    onTouchStart: e => e.preventDefault()
  };
}
const FARMSTATUS = {
  'ON': '在栏',
  'OFF': '结栏',
  'NAN': '空栏'
};
export default class FarmList extends Component {
  constructor (props) {
    super(props);
    this.state = {
      date: new Date(),
      dates: [],
      showType: '',
      batch: '',
      batchDesc: '全部批次',
      farmStatus: 'ON',
      batchList: [
        {
          farmOrg: '',
          farmOrgName: '全部批次'
        }
      ],
      list: [],
      resData: []
    }
  }
  getDates = (date) => {
    let day = date.getDate();
    let dates = [];
    for (var i = -3; i < 4; i++) {
      dates.push(new Date(date).setDate(day + i))
    }
    return dates
  };
  componentDidMount() {
    this.setState({
      dates: this.getDates(new Date())
    });
    this.getBatch()
  }
  getBatch = () => {
    Toast.loading('请稍等', 1);
    send({
      url: '/api/forward/ifarm/simpleFarmHouse/farmLocationList',
      method: 'post',
      data: {
        queryDate: df(this.state.date, 'yyyy-mm-dd'),
        type: this.state.farmStatus
      }
    }).then(res => {
      const resData = res.data;
      // 添加：全部栋批
      console.log([{
        farmOrg: '',
        farmOrgName: '全部批次'
      }, ...resData]);
      this.setState({
        batchList: [{
          farmOrg: '',
          farmOrgName: '全部批次'
        }, ...resData]
      }, () => {
        this.doSearch()
      })
    })
  };
  doSearch = () => {
    Toast.loading('请稍等', 5);
    send({
      url: '/api/forward/ifarm/simpleFarmHouse/getFarmOrgInfos',
      method: 'post',
      data: {
        farmOrg: this.state.batch,
        queryDate: df(this.state.date, 'yyyy-mm-dd'),
        type: this.state.farmStatus
      }
    }).then(res => {
      Toast.hide();
      let success = (res.status === 200);
      if (success) {
        const resData = res.data;
        this.setState({list:resData, resData})
      }
    });
  };
  componentWillUnmount() {
    Toast.hide()
  }

  renderOn = (o) => {
    return <List.Item>
      <Flex justify={'between'}
          style={{paddingBottom: 10}}
      >
        <Flex.Item>
          <span>进猪日期:</span>
          <b>{o.dateIn}</b>
        </Flex.Item>
        <Flex.Item>
          <span>饲养天数:</span>
          <b>{o.feedDays}</b>
        </Flex.Item>
      </Flex>
      <Flex justify={'between'}>
        <Flex.Item>
          <span>肥猪数量:</span>
          <b>{o.pigQty}</b>
        </Flex.Item>
        <Flex.Item>
          <span>死亡数量:</span>
          <b>{o.deadQty}</b>头
        </Flex.Item>
      </Flex>
    </List.Item>
  };
  renderOff = (o) => {
    return <List.Item>
      <Flex justify={'between'}
          style={{paddingBottom: 10}}
      >
        <Flex.Item>
          <span>进猪日期:</span>
          <b>{o.dateIn}</b>
        </Flex.Item>
        <Flex.Item>
          <span>出栏日期:</span>
          <b>{o.dateOut}</b>
        </Flex.Item>
      </Flex>
      <Flex justify={'between'}>
        <Flex.Item>
          <span>饲养天数:</span>
          <b>{o.feedDays}</b>
        </Flex.Item>
        <Flex.Item>
          <span>出栏头数:</span>
          <b>{o.outQty}</b>头
        </Flex.Item>
      </Flex>
    </List.Item>
  };
  renderList = data => {
    const {farmStatus} = this.state;
    return data.map((o,index) =>
      <WingBlank size="md"
          key={index}
      >
        <List className={'round-list'}
            onClick={() => {this.doEdit(o)}}
        >
          <List.Item className={'span-1'}
              extra={
                       <span className={o.farmStatus === 'ON' ? 'active-text': 'text-1'}>{FARMSTATUS[o.farmStatus]}</span>
                     }
          >
            <span className={'text-3'}>{o.farmOrgName}</span>
          </List.Item>
          {farmStatus==='ON'&& this.renderOn(o)}
          {farmStatus==='OFF'&& this.renderOff(o)}
          {farmStatus==='NAN' && null}
        </List>
      </WingBlank>)
  };
  doEdit = o => {
    this.props.history.replace({
      pathname: '/batch_edit',
      state: o
    })
  };
  showActionStatus = () => {
    const BUTTONS = ['在栏','结栏','空栏', '取消'];
    const VALUES = ['ON','OFF','NAN'];
    ActionSheet.showActionSheetWithOptions({
        options: BUTTONS,
        cancelButtonIndex: BUTTONS.length - 1,
        maskClosable: true,
        'data-seed': 'logId',
        wrapProps
      },
      (buttonIndex) => {
        if (buttonIndex === (BUTTONS.length - 1)) {
          //  取消
        } else  {
          this.setState(state => {
            state.farmStatus = VALUES[buttonIndex];
            state.batch = '';
            state.batchDesc = '全部批次';
            return state
          }, () => {
            this.getBatch();
          });
        }

      });
  };
  render() {
   const {date, dates,farmStatus,batchDesc} = this.state;
  return (
    <div>
      <List>
        <Flex wrap={'nowrap'}
            justify={'around'}
            style={{padding: '6px 0'}}
        >
          {
            dates.map((o, index) =>
              <div className={df(o, 'yyyy-mm-dd')===df(date, 'yyyy-mm-dd')?'loc-date active': 'loc-date'}
                  key={'date' + index}
                  onClick={() => {
                     this.setState({
                       date: new Date(o)
                     }, () => {
                       this.doSearch()
                     })
                   }}
              >
                {new Date(o).getDate()}
              </div>)
          }
          <div className="loc-date loc-datepicker"
              onClick={() => {
                 this.setState({
                   visible: true
                 })
               }}
          />
        </Flex>
      </List>
      <Flex justify={'around'}
          style={{paddingTop: 10}}
      >
         <span onClick={() => {
           this.showActionStatus('status')
         }}
         >{FARMSTATUS[farmStatus]} <Icon type={'down'}
             size={'xxs'}
                                   />
        </span>
        <span onClick={() => {
          this.setState({
            modalShow: true
          })
        }}
        >
          {batchDesc}<Icon type={'down'}
              size={'xxs'}
                     />
        </span>
      </Flex>

      {this.renderList(this.state.list)}
      {
        this.state.list.length === 0 ? <ListImg height={200} />:null
      }
      <Modal
          popup
          visible={this.state.modalShow}
          onClose={() => {
          this.setState({
            modalShow: false
          })
        }}
          animationType="slide-up"
          style={{height: 'auto'}}
      >
        <List>
          {this.state.batchList.map((o, index) => (
            <List.Item key={index}
                onClick={() => {
              if (this.state.batch === o.farmOrg) {
                console.log(1111);
                this.setState({modalShow: false})
              } else {
                this.setState({
                  batchDesc: o.farmOrgName,
                  batch: o.farmOrg,
                  modalShow: false
                }, () => {
                  this.doSearch()
                })
              }

            }}
            >
              {o.farmOrgName}
            </List.Item>
          ))}
          <List.Item>
            <div style={{textAlign: 'center'}}
                onClick={() => {
              this.setState({modalShow: false})
            }}
            >取消</div>
          </List.Item>
        </List>
      </Modal>
      <Calendar
          type={'one'}
          visible={this.state.visible}
          defaultValue={[new Date(date)]}
          onCancel={() => {
          this.setState({
            visible: false
          })
        }}
          onConfirm={() =>{
          this.setState({
            visible: false
          })
        }}
          onSelect={d => {
          this.setState({
            date: d,
            visible: false,
            dates: this.getDates(d)
          }, () => {
            this.doSearch()
          })
        }}
      />

    </div>
  )
 }
}
